module.exports = __webpack_public_path__ + "img/logoSlide4.1d7c3a7a.png";